// Templates mega menu: hovering or focusing a page-type tile cross-fades its preview set in (snippets/mm-tpl-panel.liquid).
// Design system: Navigation > page-type tiles. Motion lives in CSS (.mm-pv-set / .mm-pv-card) and is skipped for reduced motion.
class MmTplPv extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.timer = 0;
    const hover = matchMedia('(hover: hover)');
    this.addEventListener('pointerover', (e) => {
      if (!hover.matches) return;
      const tile = e.target.closest('[data-pt]');
      if (tile) this.queue(tile.dataset.pt, 90);
    });
    this.addEventListener('focusin', (e) => {
      const tile = e.target.closest('[data-pt]');
      if (tile) this.queue(tile.dataset.pt, 0);
    });
  }
  queue(key, delay) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.show(key), delay);
  }
  show(key) {
    const next = this.querySelector(`[data-pt-set="${key}"]`);
    if (!next || next.classList.contains('is-on')) return;
    for (const set of this.querySelectorAll('[data-pt-set]')) {
      const on = set === next;
      set.classList.toggle('is-on', on);
      set.inert = !on;
    }
    for (const tile of this.querySelectorAll('[data-pt]')) tile.classList.toggle('is-on', tile.dataset.pt === key);
  }
}
if (!customElements.get('mm-tpl-pv')) customElements.define('mm-tpl-pv', MmTplPv);
